export default {
  "searchResultItem": "_searchResultItem_jlag4_1",
  "searchResultItemNested": "_searchResultItemNested_jlag4_8",
  "searchResultItemText": "_searchResultItemText_jlag4_12",
  "searchResultTitle": "_searchResultTitle_jlag4_20",
  "searchResultBody": "_searchResultBody_jlag4_29",
  "searchResultWithoutTitle": "_searchResultWithoutTitle_jlag4_36",
  "searchResultAction": "_searchResultAction_jlag4_43",
  "searchResultItemStandout": "_searchResultItemStandout_jlag4_62",
  "searchResultActionIcon": "_searchResultActionIcon_jlag4_67",
  "searchResultActionText": "_searchResultActionText_jlag4_75",
  "searchResultItemActive": "_searchResultItemActive_jlag4_80",
  "searchResultIcon": "_searchResultIcon_jlag4_88",
  "searchResultItemDisabled": "_searchResultItemDisabled_jlag4_125",
  "suggestedQueryOrPrompt": "_suggestedQueryOrPrompt_jlag4_134",
  "suggestedQueryOrPromptActive": "_suggestedQueryOrPromptActive_jlag4_147",
  "promptText": "_promptText_jlag4_153",
  "icon": "_icon_jlag4_158"
};import "ni:sha-256;kacuDK4TvcNIEP3DB0Cgv-tCp89DJ8Rx2vaF6MtooF4";